import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment";

//componentes
import "./nombreAreas.css";
import Alert from "../../modal/alert";

class tiposArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      materia: "",
      descripcion: "",
      codigoM: "",
      imaterias: [],
      isalones: [],
      itipoT: [],
      inombreM: [],
      idtipoT: "",
      listaOn: false,
      modificarOn: false,
      idgrado: "",
      menoresTrue: false,
      verplanillaOn: false,
      idmenores: "0",
    };
  }

  onChange(e) {
    let index = e.target.getAttribute("id");
    //console.log(e.target.name)
    this.setState({
      [e.target.name]: e.target.value,
    });
    if (index === "idgrado") {
      this.setState({
        idtipoT: "",
      });
      if (e.target.value === "1-34") {
        this.setState({
          menoresTrue: true,
        });
      }  if (e.target.value === "1-35") {
        this.setState({
          menoresTrue: true,
        });
      }else {
        this.buscarMaterias();
      }
    }

    if (index === "idmenores") {
      this.buscarMaterias();
    }
    if (index === "idtipoT") {
      this.buscarNombreEva(e.target.value);
    }
  }

  consultar(e) {
    if (parseFloat(e) > 0) {
      let data = new FormData();
      data.append("boton", "Consultar");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/prueba/backend/boletinMaternales.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data) {
            this.setState({
              //   codigo: res.data.variable1,
              //   cedula: res.data.variable2,
              //   nombre: res.data.variable3,
              //   motivo: res.data.variable4,
              //   ordendellegada: res.data.variable5,
            });
          }
        });
    }
  }

  guardar = () => {
    if (
      this.state.idgrado.length > 0 &&
      this.state.idtipoT.length > 0 &&
      this.state.materia.length > 0
    ) {
      let data = new FormData();
      data.append("idgrado", this.state.idgrado);
      data.append("idtipoA", this.state.idtipoT);
      data.append("nombreT", this.state.materia);
      data.append("tipoMenor", this.state.idmenores);
      data.append("boton", "guardarNombreEva");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/prueba/backend/boletinMaternales.php";
      axios
        .post(xurl, data, config)

        .then((res) => {
          if (res.data.variable1) {
            this.buscarNombreEva(this.state.idtipoT);
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Crear Nombre Evalauciónreas",
              cuerpoM: res.data.variable2,
              materia: "",
            });
          } else {
            this.setState({
              mensajealerta: true,
              tituloM: "Menu Crear Nombre Evalauciónreas",
              cuerpoM: res.data.variable2,
            });
          }
        });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Crear Nombre Evalauciónreas",
        cuerpoM:
          "Debe indicar el Grado, tipo de Area y colocar el Nombre de la Evaluación, Verifique",
      });
    }
  };

  limpiar = () => {
    this.setState({
      codigoM: "",
      materia: "",
      descripcion: "",
      listaOn: false,
      modificarOn: false,
      idgrado: "",
      idtipoT: "",
    });
  };

  modificar = () => {
    let data = new FormData();
    data.append("codigoM", this.state.codigoM);
    data.append("materia", this.state.materia);
    data.append("descripcion", this.state.descripcion);
    data.append("boton", "modificarMateria");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/prueba/backend/boletinMaternales.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        if (res.data.variable1) {
          this.buscarNombreEva(this.state.idtipoT);
          this.limpiar();
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Crear Nombre Evalauciónreas",
            cuerpoM: res.data.variable2,
          });
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Crear Nombre Evalauciónreas",
            cuerpoM: res.data.variable2,
          });
        }
      });
  };

  modificarSeleccion = (e, f, g) => {
    this.setState({
      codigoM: e,
      materia: f,
      descripcion: g,
      modificarOn: true,
    });
  };

  eliminar = (e) => {
    //console.log(this.state.abonoCanje);
    if (parseFloat(e) > 0) {
      let data = new FormData();

      data.append("idnombreA", e);
      data.append("boton", "eliminarNombreA");

      let config = {
        headers: {
          "Content-Type": "text/html",
        },
      };
      const xurl =
        "https://institutobilinguelasnaciones.com/prueba/backend/boletinMaternales.php";
      axios.post(xurl, data, config).then((res) => {
        if (res.data.variable1) {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Crear Nombre Evalauciónreas.",
            cuerpoM: res.data.variable2,
          });
          this.buscarNombreEva(this.state.idtipoT);
        } else {
          this.setState({
            mensajealerta: true,
            tituloM: "Menu Crear Nombre Evalauciónreas.",
            cuerpoM: res.data.variable2,
          });
        }
      });
    } else {
      this.setState({
        mensajealerta: true,
        tituloM: "Menu Tipos de Areas.",
        cuerpoM: "Debe existir un registro para poder eliminar.",
      });
    }
  };

  buscarNombreEva = (e) => {
    let data = new FormData();

    data.append("idgrado", this.state.idgrado);
    data.append("idmenores", this.state.idmenores);
    data.append("idtipoArea", e);

    data.append("boton", "buscarNombreEva");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/prueba/backend/boletinMaternales.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let ximaterias = res.data.variable2;
        if (res.data.variable1) {
          this.setState({
            inombreM: ximaterias,
          });
        } else {
          this.setState({
            inombreM: [],
          });
        }
      });
  };

  buscarMaterias = () => {
    let data = new FormData();
    data.append("boton", "buscarMaterias");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/prueba/backend/boletinMaternales.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let ximaterias = res.data.variable2;
        if (res.data.variable1) {
          this.setState({
            itipoT: ximaterias,
          });
        } else {
          this.setState({
            itipoT: [],
          });
        }
      });
  };

  buscarSalones = () => {
    let data = new FormData();
    data.append("boton", "buscarSalonesPrimerNivel");

    let config = {
      headers: {
        "Content-Type": "text/html",
      },
    };
    const xurl =
      "https://institutobilinguelasnaciones.com/prueba/backend/boletinMaternales.php";
    axios
      .post(xurl, data, config)

      .then((res) => {
        let ximaterias = res.data.variable2;
        if (res.data.variable1) {
          this.setState({
            isalones: ximaterias,
          });
        } else {
          this.setState({
            isalones: [],
          });
        }
      });
  };

  handleClose = () => {
    this.setState({ mensajealerta: false });
  };

  componentDidMount() {
    this.buscarSalones();
  }

  render() {
    return (
      <div className="principal-pago row">
        <div className="contenedor-cxc col-12">
          <div className="titulo-cxc ">
            <p>NOMBRE DE EVALUACIONES. </p>
          </div>
          {this.state.mensajealerta === true && (
            <Alert
              tituloMensaje={this.state.tituloM}
              cuerpoMensaje={this.state.cuerpoM}
              open={this.state.mensajealerta}
              handleClose={this.handleClose}
            />
          )}
          <div className="contenedorp row">
            <div className="titulo-reprecxc row">
              <div className="contenedorcedula1f col-3">
                <select
                  id="idgrado"
                  name="idgrado"
                  value={this.state.idgrado}
                  onChange={this.onChange.bind(this)}
                >
                  <option>--Seleccionar Grado--</option>

                  {this.state.isalones.map((item, i) => {
                    return (
                      <option key={i} value={item.variable1}>
                        {item.variable2}{" "}
                      </option>
                    );
                  })}
                </select>
              </div>
              {this.state.menoresTrue && (
                <div className="contenedorcedula1f col-4">
                  <select
                    id="idmenores"
                    name="idmenores"
                    value={this.state.idmenores}
                    onChange={this.onChange.bind(this)}
                  >
                    <option>--Seleccionar--</option>
                    <option value="1">MENORES 1 AÑO</option>
                    <option value="2">MAYORES 1 AÑO</option>
                  </select>
                </div>
              )}
              <div className="contenedorcedula1f col-5">
                <select
                  id="idtipoT"
                  name="idtipoT"
                  value={this.state.idtipoT}
                  onChange={this.onChange.bind(this)}
                >
                  <option>--Tipo Area--</option>

                  {this.state.itipoT.map((item, i) => {
                    return (
                      <option key={i} value={item.variable1}>
                        {item.variable2}{" "}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
            <div className="titulo-reprecxc row">
              <div className="contenedorcedula1x col-10">
                <input
                  className="form-control"
                  type="text"
                  name="materia"
                  id="materia"
                  autoComplete="off"
                  placeholder="Nombre de Evaluación"
                  maxLength="100"
                  onChange={this.onChange.bind(this)}
                  value={this.state.materia.toUpperCase()}
                />
              </div>
            </div>
            <div className="xcontenedorcedula1x col-12">
              {!this.state.modificarOn && (
                <button className="boton" onClick={this.guardar.bind(this)}>
                  Agregar
                </button>
              )}
              {this.state.modificarOn && (
                <button className="boton" onClick={this.modificar.bind(this)}>
                  Modificar
                </button>
              )}
              <Link to="/">
                <button className="boton">Salir</button>
              </Link>
            </div>
          </div>

          <div className="cont-listmedix row">
            <div className="listcxcx col-12">
              <table className="tablacxcx" border="1">
                <thead>
                  <tr>
                    <th className="titucxc2">NOMBRE DE EVALUACION</th>
                    <th className="titucxc3x">
                      <span className="titulo-eliminar">
                        {/* <span className="cerrarme5"></span> */}
                        <span className="cerrarme3"></span>
                      </span>
                    </th>
                  </tr>
                </thead>

                {this.state.inombreM.map((item, i) => {
                  return (
                    <tr
                      className={i % 2 === 0 ? "odd" : "odd"}
                      key={item.variable1}
                      id="tabla"
                    >
                      <td className="totalescxcx">{item.variable2}</td>

                      <td className="xcerr">
                        {/* <span
                          className="cerrarme4m"
                          onClick={this.modificarSeleccion.bind(
                            this,
                            item.variable1,
                            item.variable2,
                            item.variable4
                          )}
                        ></span>{" "} */}
                        <span
                          className="cerrarme1"
                          onClick={this.eliminar.bind(this, item.variable1)}
                        ></span>{" "}
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default tiposArea;
